import { PUBLIC_HOST } from '@config/index';
import { ISiteTypesData, TLocale } from '@typescript/index';
import { fetcher } from '@utils/fetcher';
class nextSiteTypesApi {
  public endpoints = {
    getSiteTypes: () => `siteTypes`
  };
  private static fetchSiteTypes = (url: string, options: Record<string, string>, locale: TLocale) => {
    const headers = {
      'content-type': 'application/json'
    };
    return fetcher(`${PUBLIC_HOST}/api/${locale}/${url}`, {
      ...options,
      headers
    });
  };
  public async getSiteTypes(locale: TLocale): Promise<Array<ISiteTypesData>> {
    const {
      json
    } = await nextSiteTypesApi.fetchSiteTypes(this.endpoints.getSiteTypes(), {
      method: 'GET'
    }, locale);
    return json;
  }
}
export default new nextSiteTypesApi();